import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import { account } from './modules/account';
import { address } from './modules/address';
import { admin } from './modules/admin';
import { alert } from './modules/alert';
import { bookings } from './modules/bookings';
import { candidates } from './modules/candidates';
import { clients } from './modules/clients';
import { documents } from './modules/documents';
import { logs } from './modules/logs';
import { invoices } from './modules/invoices';
import { planner } from './modules/planner';
import { temp } from './modules/temp';
import { templates } from './modules/templates';
import { timesheets } from './modules/timesheets';
import { availability } from './modules/availability';
import { searches } from './modules/searches';
import { help } from './modules/help';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    address,
    alert,
    admin,
    account,
    bookings,
    candidates,
    clients,
    documents,
    logs,
    planner,
    temp,
    templates,
    timesheets,
    invoices,
    availability,
    searches,
    help,
  },
  plugins: [createPersistedState()],
});
